module.exports = __webpack_public_path__ + "img/check-circle-blue.00e338ae.svg";